/**
 * Pre-compiled pt-BR messages for ModalPage
 * Generated by @internationalized/string-compiler
 * DO NOT EDIT MANUALLY
 */

export default {
  backButton: (args: Record<string, string | number>) =>
    `Voltar para ${args.previousPathLabel}`,
};
